<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps1">
<p class="fig-img" id="map_1"><img alt="" class="image" src="images/map_1.jpg"/><span epub:type="pagebreak" id="pagex"></span></p>
<p class="fig-caption">Corsica.</p>
<p class="fig-img" id="map_2"><img alt="" class="image" src="images/map_2.jpg"/><span epub:type="pagebreak" id="pagexi"></span></p>
<p class="fig-caption">St Lucia.</p>
<p class="fig-img" id="map_3"><img alt="" class="image" src="images/map_3.jpg"/><span epub:type="pagebreak" id="pagexii"></span></p>
<p class="fig-caption">Ireland.</p>
<p class="fig-img" id="map_4"><img alt="" class="image" src="images/map_4.jpg"/><span epub:type="pagebreak" id="pagexiii"></span></p>
<p class="fig-caption">North Holland.</p>
<p class="fig-img" id="map_5"><img alt="" class="image" src="images/map_5.jpg"/><span epub:type="pagebreak" id="pagexiv"></span></p>
<p class="fig-caption">Environs of Alexandria.</p>
<p class="fig-img" id="map_6"><img alt="" class="image" src="images/map_6.jpg"/></p>
<p class="fig-caption">Lake Mareotis, Egypt.</p>
<p class="fig-img" id="map_7"><img alt="" class="image" src="images/map_7.jpg"/><span epub:type="pagebreak" id="pagexv"></span></p>
<p class="fig-caption">Sicily.</p>
<p class="fig-img" id="map_8"><img alt="" class="image" src="images/map_8.jpg"/></p>
<p class="fig-caption">Spain – the advance.</p>
<p class="fig-img" id="map_9"><img alt="" class="image" src="images/map_9.jpg"/><span epub:type="pagebreak" id="pagexvi"></span></p>
<p class="fig-caption">Spain.</p>
<p class="fig-img" id="map_10"><img alt="" class="image" src="images/map_10.jpg"/></p>
<p class="fig-caption">Battle of Corunna.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Maps1.vue?228f7962